export default "__VITE_ASSET__98lNpJ8m__"